<template>
  <div class="sidebar-nav">
    <section>
      <label>My account</label>
      <div v-if="isFutureInterestEnabled" class="link-item">
        <router-link to="/my-companies">Companies</router-link>
      </div>
      <div class="link-item">
        <router-link to="/deals/submissions">Proposals</router-link>
      </div>
      <div class="link-item">
        <router-link to="/projects">Projects</router-link>
      </div>
      <div v-if="user.isActiveSubscriber" class="search-section">
        <hr />
        <div class="link-item">
          <router-link to="/data/search/companies">Company Search</router-link>
        </div>
        <div class="link-item">
          <router-link to="/data/favorites">Favorites</router-link>
        </div>
      </div>
    </section>
    <section>
      <label>Settings</label>
      <div class="link-item">
        <router-link to="/profile">Account</router-link>
      </div>
      <div class="link-item">
        <router-link to="/projects/settings">Notifications</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'sidebar-nav',
  computed: {
    user() {
      return this.$store.state.user.currentUser
    },
    isFutureInterestEnabled() {
      return this.$store.getters.isFutureInterestEnabled
    },
  },
}
</script>

<style scoped lang="scss">
.sidebar-nav {
  width: 250px;
  margin-bottom: 30px;
  padding-top: 20px;
  padding-left: 20px;
  border-right: 1px solid #eaeaea;
}
section {
  label {
    color: #777e85;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 10px;
    margin-left: 15px;
  }
  margin-bottom: 40px;
}
.link-item {
  a {
    display: inline-block;
    width: 100%;
    color: #002560;
    font-size: $header-size-5;
    font-size: 16px;
    font-weight: 500;
    padding-top: 10px;
    padding-left: 15px;
    padding-bottom: 10px;
    border-radius: 24px 0px 0px 24px;
    &:hover {
      background: #eaeaea;
    }
    &.router-link-exact-active {
      background: #f0f8fa;
    }
  }
}
.search-section {
  margin-top: 10px;
  padding-top: 10px;
  hr {
    margin-right: 20px;
  }
}
</style>
